import api from './client'

// ── Subjects ──────────────────────────────────────────────────────────
export const listSubjects      = (params)   => api.get('/api/subjects/', { params })
export const createSubject     = (data)     => api.post('/api/subjects/', data)
export const patchSubject      = (id, data) => api.patch(`/api/subjects/${id}/`, data)
export const deleteSubject     = (id)       => api.delete(`/api/subjects/${id}/`)

// ── Topics ────────────────────────────────────────────────────────────
export const listTopics        = (params)   => api.get('/api/topics/', { params })
export const createTopic       = (data)     => api.post('/api/topics/', data)
export const updateTopic       = (id, data) => api.put(`/api/topics/${id}/`, data)
export const deleteTopic       = (id)       => api.delete(`/api/topics/${id}/`)
export const mergeTopic        = (id, tid)  => api.post(`/api/topics/${id}/merge/`, { target_id: tid })

// ── Question Banks ────────────────────────────────────────────────────
export const listQuestionBanks  = (params)   => api.get('/api/question-banks/', { params })
export const createQuestionBank = (data)     => api.post('/api/question-banks/', data)
export const updateQuestionBank = (id, data) => api.put(`/api/question-banks/${id}/`, data)
export const deleteQuestionBank = (id)       => api.delete(`/api/question-banks/${id}/`)
// Word (.docx) import — preview parses the file, save creates a NEW bank
// Upload + parse can outrun the client's default 15s timeout on a large file
export const previewWordImport  = (formData) => api.post('/api/question-banks/import-word/?preview=true', formData, { timeout: 60_000 })
export const saveWordImport     = (data)     => api.post('/api/question-banks/import-word/?preview=false', data, { timeout: 60_000 })

// ── Questions ─────────────────────────────────────────────────────────
export const listQuestions     = (params)   => api.get('/api/questions/', { params })
export const createQuestion    = (data)     => api.post('/api/questions/', data)
export const updateQuestion    = (id, data) => api.put(`/api/questions/${id}/`, data)
export const deleteQuestion    = (id)       => api.delete(`/api/questions/${id}/`)
export const copyQuestion      = (id, data) => api.post(`/api/questions/${id}/copy/`, data)

// ── Exams ─────────────────────────────────────────────────────────────
export const listExams         = (params)   => api.get('/api/exams/', { params })
export const getExam           = (id)       => api.get(`/api/exams/${id}/`)
export const createExam        = (data)     => api.post('/api/exams/', data)
export const updateExam        = (id, data) => api.put(`/api/exams/${id}/`, data)
export const deleteExam        = (id)       => api.delete(`/api/exams/${id}/`)
export const getExamResults    = (id)       => api.get(`/api/exams/${id}/results/`)
export const getExamLeaderboard = (id)      => api.get(`/api/exams/${id}/leaderboard/`)
export const resetExamAttempts = (id, data) => api.post(`/api/exams/${id}/reset-attempts/`, data)

// ── Groups ────────────────────────────────────────────────────────────
export const listGroups        = (params)   => api.get('/api/groups/', { params })
export const createGroup       = (data)     => api.post('/api/groups/', data)
export const updateGroup       = (id, data) => api.put(`/api/groups/${id}/`, data)
export const deleteGroup       = (id)       => api.delete(`/api/groups/${id}/`)
export const addGroupMember    = (id, data) => api.post(`/api/groups/${id}/add-member/`, data)
export const removeGroupMember = (id, data) => api.delete(`/api/groups/${id}/remove-member/`, { data })

// ── Users ─────────────────────────────────────────────────────────────
export const listUsers         = (params)   => api.get('/api/users/', { params })
export const createUser        = (data)     => api.post('/api/users/', data)
export const updateUser        = (id, data) => api.patch(`/api/users/${id}/`, data)
export const deleteUser        = (id)       => api.delete(`/api/users/${id}/`)

// ── Auth / Profile ────────────────────────────────────────────────────
export const updateProfile     = (data)     => api.patch('/api/auth/me/', data)
export const changePassword    = (data)     => api.post('/api/auth/change-password/', data)

// ── Grading Criteria ──────────────────────────────────────────────────
export const listGradingCriteria   = (params)   => api.get('/api/grading-criteria/', { params })
export const createGradingCriteria = (data)     => api.post('/api/grading-criteria/', data)
export const updateGradingCriteria = (id, data) => api.put(`/api/grading-criteria/${id}/`, data)
export const deleteGradingCriteria = (id)       => api.delete(`/api/grading-criteria/${id}/`)


// ── Analytics / Overview (design handoff additions) ───────────────────
export const getExamAnalytics  = (id)       => api.get(`/api/exams/${id}/analytics/`)
export const getPlatformOverview = ()       => api.get('/api/overview/')

// ── AI Provider Settings ──────────────────────────────────────────────
export const getAISettings     = ()         => api.get('/api/ai-settings/')
export const patchAISettings   = (data)     => api.patch('/api/ai-settings/', data)
export const testAISettings    = ()         => api.post('/api/ai-settings/')

// ── AI Request Logs (admin-only) ──────────────────────────────────────
export const listAiLogs = (params) => api.get('/api/ai-logs/', { params })
export const getAiLog   = (id)     => api.get(`/api/ai-logs/${id}/`)
